import { useEffect, useState } from 'react';
export var useScrollingUp = function (bool) {
    if (bool === void 0) { bool = false; }
    if (typeof window === 'undefined')
        return;
    var prevScroll = window.pageYOffset;
    var _a = useState(bool), scrollingUp = _a[0], setScrollingUp = _a[1];
    var handleScroll = function () {
        var currScroll = window.pageYOffset;
        var isScrolled = prevScroll > currScroll;
        setScrollingUp(isScrolled);
        prevScroll = currScroll;
    };
    useEffect(function () {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    return scrollingUp;
};
